export class EmailInfo {
    public Emails: string[];
    public Title: string;
    public Comment: string;
    public PdfUrl: string;
}
